/**
 * @Author: wuyang
 * @Date: 2024/1/10
 * @Description: "任务列表"
 */

import {
	DraggerUpload,
	IDraggerUploadProps
} from '@/component/dragger-upload/DraggerUpload'
import { FileAddOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { TaskItem } from '@/business-component/task-list/TaskItem'
import { useTaskListService } from '@/common/services/task-list/taskListContext'
import {
	memo,
	useContext,
	useEffect,
	useMemo,
	useReducer,
	useRef,
	useState
} from 'react'
import { message, Modal, InputNumber } from 'antd'
import { UPLOAD_MAX_RATIO, UPLOAD_MAX_SIZE } from '@/constant'
import { EBizPhone, TBizPhone } from '@/types/bizPhone'
import { useMatches, useNavigate, useParams } from 'react-router-dom'
import { useMemoizedFn } from 'ahooks'
import { useAtomManagerMethod } from '@/helper/hooks/atom-manager-method-hook/useAtomManagerMethod'
import { DocsModal } from '../docs-modal/docsModal'
import { ContextNav } from '@/layout/base/taskNavStory'
import { createTask } from '@/api/task'
// import { setData } from '@/utils/transfer'

export const TaskList = memo(() => {
	const [messageApi, messageContextHolder] = message.useMessage()
	const [modalApi, modalContextHolder] = Modal.useModal()
	const navigate = useNavigate()
	const urlParams = useParams()

	// 简单文案展示
	const [title, setTitle] = useState('')
	const [desc, setDesc] = useState('')

	const taskListService = useTaskListService()
	const [itemData, updateItem, dataList] = useAtomManagerMethod(
		taskListService.taskItemMap
	)
	//创建任务的状态
	const nowTaskType: any = useContext(ContextNav)
	const { taskType, setTasktype, taskGreat, setTaskGreat, setA, a } =
		nowTaskType
	useEffect(() => {
		console.log('点击触发任务创建状态更改', taskType, taskGreat)
	}, [taskType])

	const [isBatch, setBatch] = useState(false)
	const batchSelectItem = useRef<string[]>([])

	const [, forceUpdate] = useReducer((x) => x + 1, 0) //强刷
	const [tabType, setTabtype] = useState(0)

	//对比路径 获取任务类型
	const [lujin, setLujin] = useState(0)
	const matches = useMatches()
	const parentPath = useMemo(() => {
		return matches?.[2]?.pathname
	}, [matches])
	useEffect(() => {
		let type: EBizPhone = EBizPhone.wig
		const bizs: Record<TBizPhone, EBizPhone> = {
			real: EBizPhone.real,
			wig: EBizPhone.wig,
			mannequin: EBizPhone.mannequin,
			goods: EBizPhone.goods,
			texture: EBizPhone.texture,
			tabularasa: EBizPhone.tabularasa,
			banana: EBizPhone.banana
		}
		for (let t in bizs) {
			if (parentPath.includes(t)) {
				//通过和路径比对得出当前任务类型
				type = bizs[t as TBizPhone]
				setTabtype(type)
				console.log(type, '当前tab的类型')
				setLujin(type)
			}
		}
	}, [parentPath])

	const [imgSize, setImgSize] = useState(1600)

	const handleUpload = useMemoizedFn<Required<IDraggerUploadProps>['onUpload']>(
		({ url }) => {
			console.log(url, '点击了上传')
			// const destory = messageApi.open({
			// 	type: 'loading',
			// 	content: '任务正在创建中，请稍后',
			// 	duration: 0
			// })
			/* taskListService
				.createTask({ url }) */
			createTask({ originalUrl: url, type: taskType })
				.then((res) => {
					const { taskId, type } = res ?? {}
					console.log(type, tabType, '上传图片返回的任务类型')
					if (taskId && type == tabType) {
						navigate(`./${taskId}/task`)
					}

					return taskListService.refresh()
				})
				.finally(() => {
					// destory()
					messageApi.open({
						type: 'success',
						content: '任务创建成功'
					})
					setTaskGreat(false)
					setTasktype(lujin)
					forceUpdate()
					// eslint-disable-next-line
					// location.replace(location.pathname);
					// //任务完成更新类型
				})
		}
	)

	useEffect(() => {
		let t = title
		let d = desc
		switch (taskListService.type) {
			case EBizPhone.goods:
				t = '商品图'
				d =
					'变换产品的场景图。<br />' +
					'上传一张产品图，即可按照您的需求将您的产品放置在各种场景中生成商业摄影效果的产品图片。'
				break
			case EBizPhone.real:
				t = '真人图'
				d =
					'变换展示您服装的人和场景。<br />' +
					'上传一张穿着您服装的真人图片，即可按照您的需求生成各类真人模特穿着您服装的图片。'
				break
			case EBizPhone.wig:
				t = '假发图'
				d =
					'变换展示您头发的人和场景。<br />' +
					'上传一张假发产品图，，即可按照您的需求将您假发生成各类真人模特戴着您假发的图片。'
				break
			case EBizPhone.mannequin:
				t = '人台图'
				d =
					'将人体模特转换为穿着您服装的真人模特图。<br />' +
					'上传一张人体模特所穿服装的图片，即可按照您的需求生成各类真人模特穿着您服装的图片。'
				break
			case EBizPhone.texture:
				t = '纹理图'
				d =
					'变换展示您服装的纹理。<br />' +
					'只需简单一步,上传您的服装图片,AI帮您智能识别并提取出服装上的花色纹理图案。'
				break
			case EBizPhone.tabularasa:
				t = '白板图'
				d =
					'白板图生成功能可将您的服装图片一键转化为无花色的纯色白板图。只需上传服装图片，AI 即可智能去除原有印花与图案，生成用于贴图、定制设计器、平铺印花试样等场景的标准白板图。'
				// d =
				// 	'将您服装变换为白板图。<br />' +
				// 	'只需简单一步,上传您的服装图片,AI一键帮您智能去除服装上的花色并生成白板图。'
				break
			case EBizPhone.banana:
				t = '香蕉大模型'
				d =
					'欢迎使用香蕉Pro。<br />' +
					'用户可直接使用原生香蕉大模型进行自由对话，模型可在会话中保持上下文连续性，并基于对话内容进行记忆与理解，提升沟通效率与使用体验。'
		}

		setTitle(t)
		setDesc(d)
	}, [desc, taskListService.type, title])

	// 批量删除任务
	const handleBatchDelTask = useMemoizedFn(() => {
		const items = batchSelectItem.current
		const taskId = urlParams?.taskId
		if (items?.length > 0) {
			const delConfirm = modalApi.confirm({
				centered: true,
				title: `请确认批量删除 ${items.length} 个任务`,
				okText: '确认删除',
				cancelText: '取消删除'
			})
			delConfirm.then(
				(isConfirm) => {
					if (isConfirm) {
						taskListService.patchDeleteTask(items).then((res) => {
							messageApi.success('任务删除成功')
							batchSelectItem.current = []
							taskListService.refresh()
							delConfirm.destroy()
							if (taskId && items.includes(taskId)) {
								navigate(`/workspace/${EBizPhone[taskListService.type]}`)
							}
						})
					}
				},
				() => { }
			)
		} else {
			messageApi.warning('请选择要删除的任务')
		}
	})

	//修改图片大小
	// const handleChangeImgSize = (value: any) => {
	// 	setImgSize(value)
	// 	setData(value)
	// }

	return (
		<div className={'w-[22%] border-r-[1px] border-normal h-full'}>
			{modalContextHolder}
			{messageContextHolder}
			<div className={'p-[14px] flex flex-col h-full'}>
				<div
					className={
						'text-[18px] text-normal flex justify-between items-center'
					}
				>
					<span>
						{title}
						{taskListService.type == 5 && <a href="https://xgcis14y0p.feishu.cn/wiki/WcLkwVX13iRVnakb9W5cRBajnKb?fromScene=spaceOverview" target="_blank">
							<QuestionCircleOutlined className=' ml-[10px]' style={{ color: '#32649F', cursor: 'pointer' }} />
						</a>}
					</span>
					{/* <DocsModal title="上传指南" type={taskListService.type} /> */}
				</div>
				<div
					className={'text-subtext my-3 text-[12px]'}
					dangerouslySetInnerHTML={{ __html: desc }}
				></div>
				{/* <div
					style={{
						marginBottom: '10px',
						display: taskType == 5 ? 'block' : 'none'
					}}
				>
					图片大小：
					<InputNumber
						min={1}
						max={1600}
						defaultValue={1600}
						onChange={handleChangeImgSize}
					/>
				</div> */}
				<div>
					<DraggerUpload onUpload={handleUpload} imgSize={imgSize}>
						<div className={''}>
							<div className={''}>
								<FileAddOutlined className={'text-[18px]'} />
								<span className={'text-[18px] ml-4'}>开始新的任务</span>
							</div>
							<div className={'grid text-subtext text-[12px] mt-2 grid-cols-2'}>
								<span>· 点击上传</span>
								<span>{`· 大小 < ${Math.fround(
									UPLOAD_MAX_SIZE / 1024 / 1024
								)}M `}</span>
								<span>· 拖拽图片</span>
								<span>{`· 宽高比<${UPLOAD_MAX_RATIO}倍`}</span>
							</div>
						</div>
					</DraggerUpload>
				</div>
				<div className={'mt-[24px] overflow-hidden flex flex-col'}>
					<div className={'flex justify-between items-center'}>
						<div className={'text-[16px] text-normal'}>我的任务</div>
						<div className={'text-[14px]  cursor-pointer'}>
							{isBatch ? (
								<div className={'flex'}>
									<div
										className={'text-subtext hover:text-primary mr-[10px]'}
										onClick={() => {
											setBatch(!isBatch)
											batchSelectItem.current = []
										}}
									>
										取消
									</div>
									<div
										className={'text-[#F04040] hover:text-primary'}
										onClick={handleBatchDelTask}
									>
										确定删除
									</div>
								</div>
							) : (
								<div
									className={'text-subtext hover:text-primary'}
									onClick={() => {
										setBatch(!isBatch)
									}}
								>
									批量删除
								</div>
							)}
						</div>
					</div>
					<div
						className={
							'flex-1 h-full overflow-y-scroll scrollbar-container scrollbar-hide'
						}
					>
						{dataList.map(
							({ taskId, taskName, updateTime, originalUrl, status }) => {
								return (
									<TaskItem
										taskName={taskName}
										updateTime={updateTime}
										originalUrl={originalUrl}
										status={status}
										batchSelectItem={batchSelectItem}
										isBatch={isBatch}
										taskId={taskId}
										key={taskId}
									/>
								)
							}
						)}
					</div>
				</div>
			</div>
		</div>
	)
})
